module.exports = __webpack_public_path__ + "static/media/CEEK-BNB-APE.dac311c1.png";